import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RoleAnagrafService} from '../../../general-services/service-role-anagraf/role-anagraf.service';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-role-anagraf',
  templateUrl: './edit-role-anagraf.component.html',
  styleUrls: ['./edit-role-anagraf.component.scss']
})
export class EditRoleAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  roleAnagraf: RoleAnagrafModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  roleCod: string;
  description: string;
  roleAnagrafJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private roleAnagrafService: RoleAnagrafService, private _activatedRoute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.roleAnagrafJson = params['row'];
      });

    this.roleAnagraf = new RoleAnagrafModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      code: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.roleAnagraf = JSON.parse(this.roleAnagrafJson) as RoleAnagrafModel;

    this.formValidator.patchValue({
      code: this.roleAnagraf ? this.roleAnagraf.code : ''
    });

    this.formValidator.patchValue({
      description: this.roleAnagraf ? this.roleAnagraf.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.roleCod = params['code'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.roleAnagraf.code = this.formValidator.controls['code'].value;
      this.roleAnagraf.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.roleAnagrafService.update(this.roleAnagrafService.baseUrl, this.roleAnagraf).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Role Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Role was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
